import { Lock } from '@mui/icons-material';
import Logout from '@mui/icons-material/Logout';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import React, { FC } from 'react';
import { useAuth } from '../../Hooks/Auth';
import { getUserInitials } from '../../utils/userInitials';
import { DialogChangePassword } from '../Dialog/variants/dialog-change-password';
import { useAccountMenu } from './use-account-menu.component';

const AccountMenu : FC = () => {
  const { user } = useAuth();
  const { openDialog, setOpenDialog, loading, handleClick, handleClose, handleLogout, open, anchorEl, handleChangePassword } = useAccountMenu();

  const initials = getUserInitials(user?.username);
  const displayName = user?.username?.split('@')[0] || 'Usuário';

  return (
    <React.Fragment>
      <DialogChangePassword
        open={openDialog}
        onConfirm={handleChangePassword}
        onCancel={() => setOpenDialog(false)}
        isLoading={loading}
      />
      <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
        <Tooltip title={user?.username || 'Minha conta'}>
          <IconButton
            onClick={handleClick}
            size="small"
            sx={{ ml: 2 }}
            aria-controls={open ? 'account-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
          >
            <Avatar sx={{ width: 32, height: 32, fontSize: '0.8rem', fontWeight: 700 }}>
              {initials}
            </Avatar>
          </IconButton>
        </Tooltip>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              minWidth: 220,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <Box sx={{ px: 2, py: 1.5 }}>
          <Typography variant="subtitle2" fontWeight={700} lineHeight={1.3}>
            {displayName}
          </Typography>
          <Typography variant="caption" color="text.secondary" sx={{ wordBreak: 'break-all' }}>
            {user?.username}
          </Typography>
        </Box>
        <Divider />
        <MenuItem onClick={() => setOpenDialog(true)}>
          <ListItemIcon>
            <Lock fontSize="small" />
          </ListItemIcon>
          Trocar Senha
        </MenuItem>
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
    </React.Fragment>
  );
}

export { AccountMenu };
